module.exports = __webpack_public_path__ + "img/deliveroo.4c241bfd.png";